import { request } from "../_helpers/Auth";

const namespace = "/api/talent";

export const getDashboard = () =>
    request({ url: namespace + "/dashboard", method: "get" });

export const getSkills = () =>
    request({ url: namespace + "/skills", method: "get" });

export const createSkill = (data) =>
    request({ url: namespace + "/skills", method: "post", data });

export const updateSkill = (id, data) =>
    request({ url: namespace + "/skills/" + id, method: "put", data });

export const deleteSkill = (id) =>
    request({ url: namespace + "/skills/" + id, method: "delete" });

export const getSkillGroups = () =>
    request({ url: namespace + "/skill-groups", method: "get" });

export const createSkillGroup = (data) =>
    request({ url: namespace + "/skill-groups", method: "post", data });

export const getCompanyTeams = () =>
    request({ url: namespace + "/company-teams", method: "get" });

export const getCompanyEstablishmentsWithTeams = () =>
    request({ url: namespace + "/company-establishments", method: "get" });

export const getJobOffers = () =>
    request({ url: namespace + "/job-offers", method: "get" });

export const createJobOffer = (data) =>
    request({ url: namespace + "/job-offers", method: "post", data });

export const getJobOffer = (id) =>
    request({ url: namespace + "/job-offers/" + id, method: "get" });

export const updateJobOffer = (id, data) =>
    request({ url: namespace + "/job-offers/" + id, method: "put", data });

export const deleteJobOffer = (id) =>
    request({ url: namespace + "/job-offers/" + id, method: "delete" });

export const saveJobOfferPostcard = (id) =>
    request({ url: namespace + "/job-offers/" + id + "/postcard", method: "post" });

export const getJobOfferPostcardUrl = (id) =>
    request({ url: namespace + "/job-offers/" + id + "/postcard/url", method: "get" });

export const getCandidates = (params = {}) =>
    request({ url: namespace + "/candidates", method: "get", params });

export const createCandidate = (data) =>
    request({ url: namespace + "/candidates", method: "post", data });

export const getCandidate = (id) =>
    request({ url: namespace + "/candidates/" + id, method: "get" });

export const updateCandidate = (id, data) =>
    request({ url: namespace + "/candidates/" + id, method: "put", data });

export const updateCandidateStatus = (id, status) =>
    request({ url: namespace + "/candidates/" + id + "/status", method: "put", data: { status } });

export const updateCandidateSkills = (id, skills) =>
    request({ url: namespace + "/candidates/" + id + "/skills", method: "post", data: { skills } });

export const uploadCandidateCv = (id, formData) =>
    request({ url: namespace + "/candidates/" + id + "/cv", method: "post", data: formData });

export const getCandidateCvUrl = (id) =>
    request({ url: namespace + "/candidates/" + id + "/cv/url", method: "get" });

export const deleteCandidate = (id) =>
    request({ url: namespace + "/candidates/" + id, method: "delete" });

export const getUserSkills = (userId) =>
    request({ url: namespace + "/users/" + userId + "/skills", method: "get" });

export const updateUserSkills = (userId, skills) =>
    request({ url: namespace + "/users/" + userId + "/skills", method: "put", data: { skills } });

export const getInterviews = (params = {}) =>
    request({ url: namespace + "/interviews", method: "get", params });

export const createInterview = (data) =>
    request({ url: namespace + "/interviews", method: "post", data });

export const getInterview = (id) =>
    request({ url: namespace + "/interviews/" + id, method: "get" });

export const updateInterview = (id, data) =>
    request({ url: namespace + "/interviews/" + id, method: "put", data });

export const deleteInterview = (id) =>
    request({ url: namespace + "/interviews/" + id, method: "delete" });

export const getObjectives = (params = {}) =>
    request({ url: namespace + "/objectives", method: "get", params });

export const createObjective = (data) =>
    request({ url: namespace + "/objectives", method: "post", data });

export const getObjective = (id) =>
    request({ url: namespace + "/objectives/" + id, method: "get" });

export const updateObjective = (id, data) =>
    request({ url: namespace + "/objectives/" + id, method: "put", data });

export const deleteObjective = (id) =>
    request({ url: namespace + "/objectives/" + id, method: "delete" });

export const getTrainings = () =>
    request({ url: namespace + "/trainings", method: "get" });

export const createTraining = (data) =>
    request({ url: namespace + "/trainings", method: "post", data });

export const getTraining = (id) =>
    request({ url: namespace + "/trainings/" + id, method: "get" });

export const updateTraining = (id, data) =>
    request({ url: namespace + "/trainings/" + id, method: "put", data });

export const deleteTraining = (id) =>
    request({ url: namespace + "/trainings/" + id, method: "delete" });

export const getUserTrainings = (userId) =>
    request({ url: namespace + "/users/" + userId + "/trainings", method: "get" });

export const attachUserTraining = (userId, trainingId, status = "PLANNED") =>
    request({ url: namespace + "/user-trainings", method: "post", data: { user_id: userId, training_id: trainingId, status } });

export const detachUserTraining = (userId, trainingId) =>
    request({ url: namespace + "/user-trainings", method: "delete", data: { user_id: userId, training_id: trainingId } });

export const getCandidateTrainings = (candidateId) =>
    request({ url: namespace + "/candidates/" + candidateId + "/trainings", method: "get" });

export const attachCandidateTraining = (candidateId, trainingId, status = "PLANNED") =>
    request({ url: namespace + "/candidate-trainings", method: "post", data: { candidate_id: candidateId, training_id: trainingId, status } });

export const detachCandidateTraining = (candidateId, trainingId) =>
    request({ url: namespace + "/candidate-trainings", method: "delete", data: { candidate_id: candidateId, training_id: trainingId } });

export const attachTrainingSkill = (trainingId, talentSkillId) =>
    request({ url: namespace + "/training-skill", method: "post", data: { training_id: trainingId, talent_skill_id: talentSkillId } });

export const detachTrainingSkill = (trainingId, talentSkillId) =>
    request({ url: namespace + "/training-skill", method: "delete", data: { training_id: trainingId, talent_skill_id: talentSkillId } });

